var $, preloader;

$ = require('jquery');

preloader = {
  init: function(options) {
    var markup, parent;
    if (options === undefined || options.parent === undefined || options.parent === null) {
      parent = 'body';
      markup = '<div class="preloader"> <div class="preloader__body"></div> </div>';
    } else {
      parent = options.parent;
      markup = '<div class="preloader preloader--rel"> <div class="preloader__body"></div> </div>';
    }
    return $(parent).append(markup);
  },
  remove: function(options) {
    var parent;
    if (options === undefined || options.parent === undefined || options.parent === null) {
      parent = 'body';
    } else {
      parent = options.parent;
    }
    preloader = $(parent).find('.preloader');
    return preloader.fadeOut(300, function() {
      return $(this).remove();
    });
  }
};

module.exports = preloader;
